import Vue from 'vue';
export default Vue.extend({
    name: 'multiAssetsInfoPopupChunk',
    computed: {
        faqLink() {
            return `https://${window.location.host}/multi-assets-faq/`;
        }
    }
});
